import { ReactComponent as DownloadIcon2 } from '../img/iconDownload2.svg';
import { FC } from 'react';
import styles from './ReportDownload.module.scss';

interface ReportDownloadProps {
  onDownload: () => void;
}

export const ReportDownload: FC<ReportDownloadProps> = ({ onDownload }) => {
  return (
    <div className={styles.reportDownload} onClick={onDownload}>
      <span className={styles.reportLabel}>Отчет подтверждения</span>
      <div className={styles.reportLink}>
        <DownloadIcon2 />
      </div>
    </div>
  );
};
